import React from "react";
import { useTranslation } from "react-i18next";
import img404 from "assets/images/404.png";
import PrimaryButton from "components/common/Button/PrimaryButton";

export default function NotFoundPage({ invalidDomain }) {
  const { t } = useTranslation();

  return (
    <div className="w-screen h-screen flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4">
        <img src={img404} alt="404" className="w-96" />
        <h1 className="text-4xl font-bold">{t("pageNotFound")}</h1>
        <p className="max-w-md text-center"
        dangerouslySetInnerHTML={{ __html: t("pageNotFoundSubtitle") }}
        ></p>
        <a href={invalidDomain ? "https://nexme.ai" : "/"}>
          <PrimaryButton className="mt-5 py-2">
            {t("goToHomePage")}
          </PrimaryButton>
        </a>
      </div>
    </div>
  );
}
